import $ from "jquery"
import { trace } from "./../shared/helpers.js"


const LoaderAnimation = {

  show() {
    trace("show loader");
    $('html').addClass('loading');
  },
  hide() {
    trace("hide loader");
    $('html').removeClass('loading');
  }

}

export default LoaderAnimation;